import React from 'react';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';

interface Props {
    onClose: () => void;
}

const DebriefPopoverTitle = (props: React.PropsWithChildren<Props>) => {
    return (
        <PopoverHeader>
            <PopoverHeaderTitle>{props.children}</PopoverHeaderTitle>
            <IconButton disableRipple onClick={props.onClose}>
                <PopoverCloseIcon />
            </IconButton>
        </PopoverHeader>
    );
};

const PopoverHeader = styled(Box)`
    background-color: #203040;
    padding: 0 2px 0 17px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 2px 2px 0 0;
`;

const PopoverHeaderTitle = styled(Typography)`
    font-size: 13px;
    font-style: normal;
    font-weight: 700;
    line-height: 16px;
    color: white;
`;

const PopoverCloseIcon = styled(CancelRoundedIcon)`
    color: #8e8e93;
    font-size: 15px;
`;

export default DebriefPopoverTitle;
